export var WidgetDisplayMode;
(function (WidgetDisplayMode) {
    WidgetDisplayMode["AUTH_SCREEN"] = "authScreen";
    WidgetDisplayMode["LOGIN_BUTTON"] = "loginButton";
})(WidgetDisplayMode || (WidgetDisplayMode = {}));
//# sourceMappingURL=WidgetDisplayMode.js.map